import * as React from 'react';
import * as moment from 'moment';
import { Modal, Button, Col, FormControl, FormGroup, Form, ControlLabel } from 'react-bootstrap';
import { FormControlWrapper } from '../../../styles';
import { ITransplantDetails } from '../../../models';
import { ILogisticsProvider, IListItem, ITransportType } from '@nkr/models/index';
import { LogisticsProviders, TransportMethod } from '@nkr/enums/index';
import styled from 'styled-components';
import * as DateTimeModule from "react-datetime";

const DateTime = (DateTimeModule as any).default;

const FormGroupWrapper = styled(FormGroup)`
    display: flex;
    align-items: center;

    & > .control-label {
        padding-top: 0px;
    }
`;

interface IProps {
    show: boolean,
    transplantDetails: ITransplantDetails,
    logisticsProviders: ILogisticsProvider[],
    swapTypes: IListItem[],
    transportTypes: ITransportType[],
    onSave: (transplantDate: string, logisticsProvider: number, transportMethod: number, transportCost: number, swapType: number) => void,
    onCancel: () => void
}

interface IState {
    transplantDate: string,
    logisticsProvider: number,
    transportMethod: number,
    transportMethodIsValid: boolean,
    transportCost: string,
    transportCostIsValid: boolean,
    swapType: number,
    showCost: boolean
}

class TransplantDetails extends React.Component<IProps, IState> {
    readonly state: IState = {
        transplantDate: '',
        logisticsProvider: 0,
        transportMethod: -1,
        transportMethodIsValid: false,
        transportCost: '',
        transportCostIsValid: true,
        swapType: 0,
        showCost: false
    }

    getEnableSave = () => {        
        return !(this.state.transportMethod > 0);      
    }

    componentWillReceiveProps = (nextProps: IProps) => {
        if (nextProps.show) {
            let { transplantDate, logisticsProvider, transportMethod, transportCost, swapType, donorCenterId, rdnCenterId, recipientCenterId } = nextProps.transplantDetails;

            let isNoCost = logisticsProvider == LogisticsProviders.LocalOpo || transportMethod == TransportMethod.Internal;
            let isStatic = (logisticsProvider == LogisticsProviders.Sterling || logisticsProvider == LogisticsProviders.Nora) && (transportMethod == TransportMethod.Commercial || transportMethod == TransportMethod.Ground || transportMethod == TransportMethod.CommObc || transportMethod == TransportMethod.CommOneLegObc);

            let showCost = (isNoCost || isStatic) == false && transportMethod > 0;

            let donorCenter = rdnCenterId > 0 ? rdnCenterId : donorCenterId;

            if (transportMethod == 0 && donorCenter == recipientCenterId) {
                transportMethod = TransportMethod.Internal;
            }

            if (logisticsProvider == 0 && donorCenter == recipientCenterId) {
                logisticsProvider = LogisticsProviders.LocalOpo;
            }

            this.setState({
                transplantDate,
                logisticsProvider,
                transportMethod,
                transportMethodIsValid: transportMethod >= 0,
                transportCost: transportCost.toString(),
                transportCostIsValid: true,
                swapType,
                showCost
            });
        }
    }

    handleTransplantDateChange = (e: moment.Moment) => {
        this.setState({
            transplantDate: e.format()
        });
    }

    handleLogisticsProviderChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            logisticsProvider: parseInt(e.currentTarget.value)
        });
    }

    handleTransportMethodChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        var transportMethod = parseInt(e.currentTarget.value);
        var provider = this.props.transplantDetails.logisticsProvider;

        var isNoCost = provider == LogisticsProviders.LocalOpo || transportMethod == TransportMethod.Internal;
        var isStatic = (provider == LogisticsProviders.Sterling || provider == LogisticsProviders.Nora) && (transportMethod == TransportMethod.Commercial || transportMethod == TransportMethod.Ground || transportMethod == TransportMethod.CommObc || transportMethod == TransportMethod.CommOneLegObc);

        let showCost = (isNoCost || isStatic) == false && transportMethod > 0;

        this.setState({
            transportMethod,
            transportMethodIsValid: transportMethod > 0,
            showCost
        });
    }

    handleTransportCostChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        this.setState({
            transportCost: e.currentTarget.value
        });
    }

    handleSwapTypeChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            swapType: parseInt(e.currentTarget.value)
        });
    }

    handleSave = () => {
        let { transplantDate, logisticsProvider, transportMethod, transportCost, swapType, showCost } = this.state;

        let transportCostIsValid = true;

        if (showCost && transportCost == '')
            transportCostIsValid = false;

        if (showCost && transportCost != '' && Number.isNaN(Number(transportCost)))
            transportCostIsValid = false;

        let transportMethodIsValid = transportMethod > 0;

        this.setState({
            transportMethodIsValid,
            transportCostIsValid
        }, () => {
            if (transportMethodIsValid && transportCostIsValid) {
                this.props.onSave(transplantDate, logisticsProvider, transportMethod, transportCost != '' ? parseInt(transportCost) : 0, swapType);
            }
        });
    }

    handleCancel = () => {
        this.props.onCancel();
    }

    render = () => {
        const enableSave = this.getEnableSave();

        return (
            <Modal show={this.props.show} onHide={() => null}>
                <Modal.Header>
                    <Modal.Title>Transplant Details</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form horizontal>
                        <FormGroupWrapper>
                            <Col componentClass={ControlLabel} xs={12} lg={4} style={{ paddingTop: 0 }}>
                                Transplant Date:
                            </Col>
                            <Col xs={12} lg={8}>
                                {this.props.transplantDetails.transplantDate != "" ?
                                    <div className="form-control" style={{ padding: "3px 6px", height: 26 }}>
                                        {this.state.transplantDate}
                                    </div>
                                    :
                                    <DateTime
                                        value={this.state.transplantDate}
                                        input={true}
                                        dateFormat={"MM/DD/YY"}
                                        timeFormat={"HH:mm"}
                                        closeOnSelect={true}
                                        inputProps={{ style: { padding: "3px 6px", height: 26 } }}
                                        onChange={this.handleTransplantDateChange}
                                    />
                                }
                            </Col>
                        </FormGroupWrapper>

                        <FormGroupWrapper style={{ display: "flex", alignItems: "center" }}>
                            <Col componentClass={ControlLabel} xs={12} lg={4} style={{ paddingTop: 0 }}>Logistics Provider:</Col>
                            <Col xs={12} lg={8}>
                                <FormControlWrapper
                                    componentClass="select"
                                    value={this.state.logisticsProvider}
                                    onChange={this.handleLogisticsProviderChange}
                                >
                                    {this.props.logisticsProviders.map((item, index) =>
                                        <option key={index} value={item.id}>{item.description}</option>
                                    )}
                                </FormControlWrapper>
                            </Col>
                        </FormGroupWrapper>

                        <FormGroupWrapper style={{ marginBottom: !this.state.transportMethodIsValid ? 0 : 15 }} validationState={!this.state.transportMethodIsValid ? "error" : null}>
                            <Col componentClass={ControlLabel} xs={12} lg={4}>Transport Method:</Col>
                            <Col xs={12} lg={8}>
                                <FormControlWrapper
                                    componentClass="select"
                                    value={this.state.transportMethod==0?-1:this.state.transportMethod}
                                    onChange={this.handleTransportMethodChange}                                  
                                >
                                    <option value='-1'>- select method -</option>
                                    {this.props.transportTypes.map((item, index) =>                                                                        
                                        <option hidden={item.id==0?true:false} key={index} value={item.id}>{item.description}</option>
                                    )}
                                </FormControlWrapper>
                            </Col>
                        </FormGroupWrapper>
                        {!this.state.transportMethodIsValid ?
                            <FormGroupWrapper>
                                <Col xs={12} lg={4}></Col>
                                <Col xs={12} lg={8} className="text-danger">
                                    The transport method must be selected
                                </Col>
                            </FormGroupWrapper>
                            : null}

                        {this.state.showCost ?
                            <>
                                <FormGroupWrapper style={{ marginBottom: !this.state.transportCostIsValid ? 0 : 15 }} validationState={!this.state.transportCostIsValid ? "error" : null}>
                                    <Col componentClass={ControlLabel} xs={12} lg={4}>Transportation Cost:</Col>
                                    <Col xs={12} lg={8}>
                                        <FormControlWrapper
                                            type="text"
                                            value={this.state.transportCost}
                                            onChange={this.handleTransportCostChange}
                                        />
                                    </Col>
                                </FormGroupWrapper>
                                {!this.state.transportCostIsValid ?
                                    <FormGroupWrapper>
                                        <Col xs={12} lg={4}></Col>
                                        <Col xs={12} lg={8} className="text-danger">
                                            The cost must be a valid numeric value
                                        </Col>
                                    </FormGroupWrapper>
                                    : null}
                            </>
                            : null}

                        <FormGroupWrapper>
                            <Col componentClass={ControlLabel} xs={12} lg={4}>Swap Type:</Col>
                            <Col xs={12} lg={8}>
                                <FormControlWrapper
                                    componentClass="select"
                                    value={this.state.swapType}
                                    onChange={this.handleSwapTypeChange}
                                >
                                    {this.props.swapTypes.map((item, index) =>
                                        <option key={index} value={item.id}>{item.description}</option>
                                    )}
                                </FormControlWrapper>
                            </Col>
                        </FormGroupWrapper>
                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Button bsStyle="primary" disabled={enableSave} onClick={this.handleSave}>Update Transplant Details</Button>
                    <Button onClick={this.handleCancel}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default TransplantDetails;